import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'iui-iconectiv-lib';
import { RefdataService, CustomerSupportInfo } from '../shared/refdata.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html'
})
export class SupportComponent extends BaseComponent implements OnInit {

  public info: CustomerSupportInfo;
  public year = 2017;

  constructor(private refdataService: RefdataService) {
    super();
    const dt = new Date();
    this.year = dt.getFullYear();
  }

  ngOnInit() {
    this.refdataService.getRefdata().subscribe(
      rsp => {
        this.info = rsp.customersupport;
        this.info.holidayList = this.info.holidayList.filter(h => (h.holidayDateTime.getFullYear() === this.year));
        const now = new Date().getTime();
        this.info.scheduledDowntimeList = this.info.scheduledDowntimeList.filter(sdt => {
          return (sdt.endDateTime.getTime() > now);
        });
      },
      error => this.log.error('error retrieving refdata' + error)
    );
  }
}
